import styled from 'styled-components';

export default styled.div`
	margin: 1em;
	position: relative;
`;
